import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#2D2825] text-[#F5EFE6] mt-auto">
      <div className="px-4 sm:px-6 lg:px-12 max-w-7xl mx-auto py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-xl bg-[#7A222B] flex items-center justify-center">
              <Sparkles className="w-5 h-5 text-[#FDF0EC]" />
            </div>
            <span className="font-display text-2xl" style={{ fontWeight: 800 }}>Master</span>
          </div>
          <p className="mt-4 text-[#948A80] max-w-sm leading-relaxed">
            The career network for the best AI talent — jobs, internships and paid AI projects in one place.
          </p>
        </div>
        <div>
          <h4 className="font-semibold text-sm uppercase tracking-[0.2em] text-[#D4A359] mb-4">Explore</h4>
          <ul className="space-y-3 text-[#C9C0B6]">
            <li><Link to="/jobs" className="hover:text-white transition-colors">Jobs & Internships</Link></li>
            <li><Link to="/projects" className="hover:text-white transition-colors">AI Projects</Link></li>
            <li><Link to="/employers" className="hover:text-white transition-colors">Employers</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold text-sm uppercase tracking-[0.2em] text-[#D4A359] mb-4">Get started</h4>
          <ul className="space-y-3 text-[#C9C0B6]">
            <li><Link to="/register" className="hover:text-white transition-colors">Create account</Link></li>
            <li><Link to="/login" className="hover:text-white transition-colors">Sign in</Link></li>
            <li><a href="mailto:hello@joinmaster.ai" data-testid="footer-contact-email" className="hover:text-white transition-colors">hello@joinmaster.ai</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#453E39] py-6 text-center text-sm text-[#948A80]">
        © 2026 Master · The career network for the AI economy
      </div>
    </footer>
  );
}
